module.exports = __webpack_public_path__ + "img/電気回路_6_7_3.58dbc761.png";